import type { Connection, Edge } from '@xyflow/react';

/**
 * Один аккуратный исход с каждой source-ручки: без ручки / пусто → как у линейных узлов (`out`).
 * Условие (yes/no) и A/B (a/b) остаются с отдельной ручкой каждая — по одной линии на ручку.
 */
export function normalizeEdgeSourceHandle(sourceHandle?: string | null): string {
  if (sourceHandle == null || sourceHandle === '') return 'out';
  return sourceHandle;
}

/** Удаляет рёбра с тем же источником и той же нормализованной ручкой (перед добавлением нового). */
export function stripEdgesSharingSourceHandle(
  edges: readonly Edge[],
  c: Pick<Connection, 'source' | 'sourceHandle'>
): Edge[] {
  const want = normalizeEdgeSourceHandle(c.sourceHandle);
  return edges.filter(
    (e) => !(e.source === c.source && normalizeEdgeSourceHandle(e.sourceHandle) === want)
  );
}

export function hasDuplicateOutgoingBySourceHandle(edges: readonly Edge[]): boolean {
  const seen = new Set<string>();
  for (const e of edges) {
    const k = `${e.source}\0${normalizeEdgeSourceHandle(e.sourceHandle)}`;
    if (seen.has(k)) return true;
    seen.add(k);
  }
  return false;
}
